import Icon from "../icons/Icon";

// The one button. `as` swaps the element (as={Link} to="/x"); everything else
// is a native prop. Defaults to type="button" so it never submits a form by
// accident; pass type="submit" where needed.
export default function Button({
  variant = "primary",
  size = "md",
  icon,
  iconRight,
  loading = false,
  fullWidth = false,
  as: Component = "button",
  className = "",
  children,
  disabled,
  ...rest
}) {
  const isNativeButton = Component === "button";
  const classes = [
    "rl-btn",
    `rl-btn--${variant}`,
    `rl-btn--${size}`,
    fullWidth ? "rl-btn--full" : "",
    className,
  ].filter(Boolean).join(" ");
  const iconSize = size === "lg" ? 20 : 16;
  const props = isNativeButton
    ? { type: "button", disabled: disabled || loading, ...rest }
    : { "aria-disabled": disabled || loading ? "true" : undefined, ...rest };

  return (
    <Component className={classes} aria-busy={loading ? "true" : undefined} {...props}>
      {loading ? <span className="rl-btn__spinner" aria-hidden="true" /> : icon && <Icon name={icon} size={iconSize} />}
      {children}
      {iconRight && !loading && <Icon name={iconRight} size={iconSize} />}
    </Component>
  );
}
